<div class="layout-dashboard">
    <div class="grid">
        <div class="col-12 xl:col-12">
            <div class="card mx-1 bg-card mx-0">
                <div
                    class="flex w-full justify-content-between align-items-start mb-2"
                >
                    <div class="flex align-items-start gap-3">
                        <img *ngIf="getDeviceType()==='desktop' || getDeviceType()==='desktop'; else mobileIcon" class="title-image" src="../../../../assets/demo/images/fleet-supervisor.gif">
                        <ng-template #mobileIcon>
                            <img class="title-image mobile-icon" src="../../../../assets/demo/images/fleet-supervisor.gif">
                        </ng-template>
                        
                        <div class="flex flex-column pt-1">
                            <h5 class="mb-0 pb-0">{{ "DRIVERS" | translate }}</h5>
                            <small class="list-stats text-xs">{{nonCompliantCount}} {{'non-compliant drivers' | translate}}</small>
                        </div>
                    </div>
                    <button
                        *ngIf="getDeviceType()==='desktop' || getDeviceType()==='tablet'"
                        type="button"
                        pButton
                        pRipple
                        [pTooltip]="'ADD_DRIVER' | translate"
                        class="p-button p-button-primary add-button"
                        icon="pi pi-plus"
                        [label]="'ADD_DRIVER' | translate"
                        (click)="addDriverClicked()"
                    ></button>
                    <button *ngIf="getDeviceType()==='mobile'" type="button"
                            pButton
                            pRipple
                            pTooltip="Add new driver"
                            class="p-button p-button-primary add-button"
                            icon="pi pi-plus"
                            (click)="addDriverClicked()"></button>
                </div>
                <div class="spacer"></div>
                <p-table
                    [value]="drivers"
                    [paginator]="true"
                    [rows]="10"
                    responsiveLayout="scroll"
                    *ngIf="(getDeviceType()==='desktop' || getDeviceType()==='tablet')"
                >
                    <ng-template pTemplate="header">
                        <tr >
                            <th>{{ "FULL_NAME" | translate }}</th>
                            <th>{{ "DATE_OF_BIRTH" | translate }}</th>
                            <th>{{ "ID_NO" | translate }}</th>
                            <th>{{ "GENDER" | translate }}</th>
                            <th>{{ "KYC" | translate }}</th>
                            <th>{{ "STATUS" | translate }}</th>
                            <th>{{ "ACTIONS" | translate }}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-driver>
                        <tr [ngClass]="rowClass(driver)">
                            <td>
                                <span class="p-column-title">Full Name</span>
                                {{ driver.firstname }} {{ driver.surname }}
                            </td>
                            <td>
                                <span class="p-column-title"
                                    >Date of Birth</span
                                >
                                {{ driver.dateOfBirth | date : "dd-MMM-yyyy" }}
                            </td>
                            <td>
                                <span class="p-column-title">ID No.</span>
                                {{ driver.identificationNumber }}
                            </td>
                            <td>
                                <span class="p-column-title">Gender</span>
                                {{ driver.gender | translate }}
                            </td>
                            <td>
                                <span class="p-column-title">KYC Status</span>
                                {{ driver.kycStatus | translate }}
                            </td>
                            <td>
                                <span class="p-column-title"
                                    >Profile Status</span
                                >
                                {{ driver.status | translate }}
                            </td>
                            <td>
                                <p-button
                                    class="table-button"
                                    [pTooltip]="'VIEW_DRIVER' | translate"
                                    icon="pi pi-info-circle"
                                    [rounded]="true"
                                    [text]="true"
                                    (onClick)="viewDriverDetails(driver)"
                                    severity="info"
                                />
                                <p-button
                                    *ngIf="false"
                                    (click)="deleteDriver(driver.id)"
                                    class="table-button delete-driver"
                                    [pTooltip]="'DEACTIVATE_DRIVER' | translate"
                                    icon="pi pi-trash"
                                    [rounded]="true"
                                    [text]="true"
                                    [style]="{ 'background-color': 'white' }"
                                    severity="danger"
                                />
                             
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <ng-container *ngIf="getDeviceType() === 'mobile'" [style.height.px]="getDeviceHeight()">
                    <div class="driver-tiles-container ">
                        <div class="driver-item-container flex flex-column" *ngFor="let driver of drivers">
                            <app-driver-list-card (click)="viewDriverDetails(driver)" class="my-2"  [driver]="driver"></app-driver-list-card>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
